module.exports = __webpack_public_path__ + "static/media/MultipleUser.e0ae7c6b.svg";